import { Dispatch, SetStateAction } from "react";
import { Typography } from "@material-ui/core";
import { BundlesStorageList } from "./BundlesStorageList";
import { CustomTablePagination } from "../../shared/CustomTablePagination/CustomTablePagination";
import { ModelBundle } from "../../../generated/graphql";

interface BundlesTableListProps {
  loading: boolean;
  models: Partial<ModelBundle>[];
  total: number;
  page: number;
  rowsPerPage: number;
  setIsOpenModal: Dispatch<SetStateAction<{ isOpen: boolean; id: string }>>;
  setPage: Dispatch<SetStateAction<number>>;
  setRowsPerPage: Dispatch<SetStateAction<number>>;
}

export const BundlesTableList = ({
  loading,
  models,
  total,
  page,
  rowsPerPage,
  setIsOpenModal,
  setPage,
  setRowsPerPage,
}: BundlesTableListProps) => {
  return (
    <>
      {!loading && !models.length ? (
        <Typography
          variant="subtitle1"
          color="textSecondary"
          align="center"
          style={{ margin: "40px" }}
        >
          За вашим запитом нічого не знайдено. Спробуйте змінити параметри
          пошуку або фільтри. Або додайте нову модель у сховище.
        </Typography>
      ) : (
        <>
          <BundlesStorageList
            models={models}
            onOpenModal={(id) => setIsOpenModal({ isOpen: true, id })}
          />
          <CustomTablePagination
            rowsPerPageOptions={[10, 20]}
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(_, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(+e.target.value);
              setPage(0);
            }}
          />
        </>
      )}
    </>
  );
};
